import { gql } from '@apollo/client';
import { useFetchCallback } from './useFetchCallback';

const GET_INVESTED_AND_MARKET_VALUE = gql`
  query GetInvestedAndMarketValue($data: investedAndMarketValue!) {
    getInvestedAndMarketValue(data: $data) {
      CumulativeNetInvested
      MarketValue
      Date
    }
  }
`;

const GET_INVESTED_AND_MARKET_VALUE_BACKUP = gql`
  query GetInvestedAndMarketValueBackup($data: investedAndMarketValueBackup!) {
    getInvestedAndMarketValueBackup(data: $data) {
      CumulativeNetInvested
      MarketValue
      Date
    }
  }
`;

export const useGetInvestedAndMarketValueWithFallback = variables => {
  return useFetchCallback(GET_INVESTED_AND_MARKET_VALUE, GET_INVESTED_AND_MARKET_VALUE_BACKUP, {
    variables,
    fetchPolicy: 'no-cache',
  });
};
